module.exports = __webpack_public_path__ + "img/horizontal-inactive.02263b0b.svg";